/**
 * Created by Daniela on 11/10/2016.
 */
import { ValidationResult } from "../../../../shared/validators/interface.validation";
import { grupoMaterialCodigoMask } from "../data.service";

export class GrupoMaterialCodigoValidator {
    static grupoMaterialCodigoFormat(item: any): ValidationResult {
        var code: any = item.value,
            codeNumber: number;

        if (code) {
            code = code.toString();
            code = code.replace(/\D/g, '');
            codeNumber = parseInt(code);

            if ((code.length !== grupoMaterialCodigoMask) || (codeNumber <= 0)) {
                return { "incorrectCodigoFormat": true };
            }

            return null;
        }
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/grupos-materiais/shared/validators/grupo-material-codigo.validator.ts
 **/